import {Component, OnInit} from '@angular/core';
import {FloatButtonModel} from "../../float-button";
import {InfoService} from "../../info/info.service";

@Component({
  selector: 'yz-layout',
  templateUrl: './yz-layout.component.html',
  styleUrls: ['./yz-layout.component.less']
})
export class YzLayoutComponent implements OnInit {
  color = '';
  buttons: FloatButtonModel[] = [
    {icon: 'back', title: '返回', click: () => this.goBack()},
    {icon: 'home', title: '主页', click: () => this.goHome()},
  ]

  get title(): string {
    return document.title;
  }

  constructor(private infoService: InfoService) {
  }

  ngOnInit() {
    this.infoService.getSystemInfo().subscribe(res => {
      if (res.clientEnd && res.clientEnd.color) {
        this.color = res.clientEnd.color;
      }
    })
  }

  goBack() {
    window.history.back();
  }

  goHome() {
    window.location.href = '/backstage/wechat/mp/main';
  }
}
